module.exports = __webpack_public_path__ + "static/media/MOBIROBO.76acd6af.png";